import { offices, type Office } from "./addressBook.service";

const OFFICES_PAGE_SIZE = 500;

export async function loadAllOfficesForCompany(companyId: string): Promise<Office[]> {
  const accumulated: Office[] = [];
  let offset = 0;
  let total = Infinity;
  while (accumulated.length < total) {
    const response = await offices.getAll({ companyId, limit: OFFICES_PAGE_SIZE, offset });
    accumulated.push(...response.data);
    total = response.pagination.total;
    offset += response.data.length;
    if (response.data.length === 0) break;
  }
  return accumulated;
}
